/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 *
 * The shapes the permissions editor works in. Mirrors the API's APP_GRANTS and the
 * permissions jsonb on profile / customer_profile.
 */

export const APP_GRANTS = ['assetMap', 'trackerMap', 'coldStorage', 'blastFreezer', 'auditLogs', 'geofences'] as const

export type AppGrant = (typeof APP_GRANTS)[number]

export const isAppGrant = (value: unknown): value is AppGrant =>
  typeof value === 'string' && (APP_GRANTS as readonly string[]).includes(value)

export const APP_GRANT_LABELS: Record<AppGrant, string> = {
  assetMap: 'Asset List',
  trackerMap: 'Tracker Map',
  coldStorage: 'Cold Storage',
  blastFreezer: 'Blast Freezer',
  auditLogs: 'Audit Logs',
  geofences: 'Geofences',
}

/** Editor state: the checked apps and the checked insight slugs, always explicit. */
export interface PermissionsValue {
  grants: AppGrant[]
  insights: string[]
}

/**
 * What the company allows. `hasProfile` false means the company has never been
 * configured and caps nothing; an empty `insights` list caps no insights.
 */
export interface PermissionsCap {
  grants: AppGrant[]
  insights: string[]
  hasProfile: boolean
  companyName: string
}
